import type { ILabelProps } from './Label'

import { styled } from '@linaria/react'
import { COLOR } from 'vars/color'
import { FIXED_INDENTS } from 'vars/fixed-indents'
import { LabelsOrder } from './Label.h'

export const LabelStyled = styled.div<Omit<ILabelProps, 'title'>>`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  min-width: ${({ sliding }) => (sliding ? 0 : 'auto')};
  max-width: 100%;
  width: ${({ fluid }) => (fluid ? '100%' : 'auto')};
  background: ${({ background }) =>
    background ? `var(${background})` : 'none'};
  color: ${({ color }) => (color ? `var(${color})` : 'unset')};
  padding: ${({ padding }) =>
    padding && padding.length ? padding.join(' ') : 0};
  box-shadow: ${({ borders, borderColor }) =>
    borders && borderColor
      ? `inset 0 0 0 var(${borders}) var(${borderColor})`
      : 'unset'};
  border-radius: ${({ corners }) => (corners ? `var(${corners})` : 0)};
  order: ${({ order }) => (order ? order : LabelsOrder.ORDER_1)};
`

export const IsLiveSC = styled.div`
  height: 0.5rem;
  width: 0.5rem;
  border-radius: 50%;
  background-color: var(${COLOR.ADDITIONAL_RED_2});
  margin-right: var(${FIXED_INDENTS.INDENT_10});
`
